import { OrderSubLineItem } from "@amzn/ito-client";
import { HardwareOrderStatus } from "interfaces";

export interface StatusRule {
    condition: (item: Partial<OrderSubLineItem>) => boolean;
    status: string;
}

export const STATUS_RULES: StatusRule[] = [
    {
        condition: (item) => {
            const hasPO = !!item.poNumber?.trim();
            const hasDeliveredQty = !!item.quantityDelivered && item.quantityDelivered > 0;
            return hasPO && hasDeliveredQty;
        },
        status: HardwareOrderStatus.DELIVERED,
    },
    {
        condition: (item) => !!item.poNumber?.trim(),
        status: HardwareOrderStatus.PENDING_DELIVERY,
    },
    {
        condition: (item) => {
            const hasVendor = !!item.vendor?.trim();
            const hasPR = !!item.prNumber?.trim();
            return hasVendor && hasPR;
        },
        status: HardwareOrderStatus.PENDING_APPROVAL,
    },
];

/**
 * Determines the automatic status for a sub-line item by evaluating rules in order.
 * Returns the status of the first matching rule, or undefined if no rule matches.
 */
export const determineAutoStatus = (item: Partial<OrderSubLineItem>): string | undefined => {
    const matchedRule = STATUS_RULES.find((rule) => rule.condition(item));
    return matchedRule?.status;
};